module.exports = __webpack_public_path__ + "img/kefu_qr.1ea37dcb.jpg";